import { useQuery } from "@tanstack/react-query";
import { CampaignApi } from "service/api/campaign.api";
import { QUERY_KEYS } from "service/constant/query-keys";

export const useGetListCampaign = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.INBOUND_CALL_LOGS, params],
    queryFn: async () => {
      const res = await CampaignApi.getListCampaign(params);
      return res.data;
    },
    ...options,
  });
};
